export default __webpack_public_path__ + "static/media/sendToback.81ebdad3.png";